import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { popSnackbar } from 'FRONTEND/actions/app';
import SuggestedBrowsers from 'FRONTEND/components/SuggestedBrowsers';
import { browserSupportStatus, checkBrowser, getOsSupportedBrowsers } from 'FRONTEND/utils/browser';
import i18n from 'FRONTEND/utils/i18n';

const SnackbarDispatcher = () => {
  /**
   * Snackbar used to display app notifications to the user.
   */
  const dispatch = useDispatch();
  const snackbarsList = useSelector((state) => state.app.snackbars);
  const browserSupport = useSelector((state) => state.app.browserSupport);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (checkBrowser() !== browserSupportStatus.SUPPORTED) {
      const variant = 'warning';
      const message = i18n._('Warning: your browser seems to be outdated. Please consider updating to a more recent browser.');
      enqueueSnackbar(message, {
        persist: true,
        variant,
        action: () => (
          <SuggestedBrowsers suggestedBrowsers={getOsSupportedBrowsers()} />
        ),
      });
    }
  }, []);

  useEffect(() => {
    if (snackbarsList && snackbarsList.length) {
      const snackbar = { ...snackbarsList[0] };

      if (snackbar.link) {
        if (snackbar.message.slice(-1) === '.') {
          snackbar.message = snackbar.message.slice(0, -1);
        }
        snackbar.message = `${snackbar.message}: <a data-pjax class="snackbar-link" href="${snackbar.link}">${i18n._('link')}</a>.`;
      }
      // Necessary to display hypertext link on Snackbar message as React automatically escapes all HTML strings.
      snackbar.message = <div dangerouslySetInnerHTML={{ __html: `${snackbar.message}` }} />;
      const snackBarConfig = {
        variant: snackbar.variant,
        action: (key) => (
          <IconButton onClick={() => closeSnackbar(key)} color='inherit' size='large'>
            <CloseIcon />
          </IconButton>
        ),
      };
      if (snackbar.autoHideDuration) {
        snackBarConfig.autoHideDuration = snackbar.autoHideDuration;
      }
      enqueueSnackbar(snackbar.message, snackBarConfig);

      dispatch(popSnackbar());
    }
  }, [snackbarsList]);

  // We return an empty div so that if this component is already mounted it doesn't unmount and remount itself.
  // FIXME: find another way to do it once branch 1246 is merged.
  return browserSupport === browserSupportStatus.OUTDATED ? (
    <SuggestedBrowsers>
      <div className='supportedBrowsers-content'>{i18n._('Your browser (or its version) isn’t compatible with the telemedecine solution.')}</div>
      <div className='supportedBrowsers-content'>{i18n._('Please contact your administrator or download a compatible browser.')}</div>
    </SuggestedBrowsers>
  ) : '';
};

export default SnackbarDispatcher;
